var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaximize01 = function SvgMaximize01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 21.5V16H4v2.946l4.35-4.35 1.054 1.054L5.054 20H8v1.5zm13.5 0V20h2.946l-4.35-4.35 1.054-1.054 4.35 4.35V16h1.5v5.5zM8.35 9.404 4 5.054V8H2.5V2.5H8V4H5.054l4.35 4.35zm7.3 0L14.596 8.35 18.946 4H16V2.5h5.5V8H20V5.054z"
  })));
};
export default SvgMaximize01;